import { render, staticRenderFns } from "./Asq3FollowUp.vue?vue&type=template&id=61c662c6&scoped=true&"
import script from "./Asq3FollowUp.vue?vue&type=script&lang=js&"
export * from "./Asq3FollowUp.vue?vue&type=script&lang=js&"
import style0 from "./Asq3FollowUp.vue?vue&type=style&index=0&id=61c662c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c662c6",
  null
  
)

export default component.exports